import { render, staticRenderFns } from "./OrganisationInfo.vue?vue&type=template&id=7a236fe5&scoped=true&"
import script from "./OrganisationInfo.vue?vue&type=script&lang=js&"
export * from "./OrganisationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationInfo.vue?vue&type=style&index=0&id=7a236fe5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a236fe5",
  null
  
)

export default component.exports